import { $, $$ } from "@utils/dom";
import { on, off } from "@utils/listener";

class ProductPreview {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.links = [ ...$$('.product-preview__medias, .product-preview__link', this.el) ];
    this.img = $('.product-preview__img', this.el);
    this.price = $('.product-preview__price', this.el);
    this.variants = [ ...$$('.product-preview__variant', this.el) ].map(variant => new ProductVariant(variant));

    this._onVariantClick = this._onVariantClick.bind(this);
  }

  init() {
    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();
    if( this.variants ) this.variants.forEach(variant => variant.destroy());

    this.el = null;
    this.emitter = null;
    this.links = null;
    this.img = null;
    this.price = null;
    this.variants = null;

    this._onVariantClick = null;
  }

  _bindEvents() {
    if( this.variants ) this.variants.forEach(variant => on(variant.el, 'click', this._onVariantClick));
  }
  _unbindEvents() {
    if( this.variants ) this.variants.forEach(variant => off(variant.el, 'click', this._onVariantClick));
  }

  _onVariantClick(event) {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    const variant = this.variants.find(variant => variant.el === event.currentTarget);
    if( !variant || variant.selected ) return;

    this.variants.forEach(v => v.selected = v === variant);
    this.links.forEach(link => link.href = variant.url);

    this.price.innerHTML = variant.price;
    if( variant.src ) this.img.src = variant.src;
    if( variant.srcset ) this.img.srcset = variant.srcset;
    if( variant.sizes ) this.img.sizes = variant.sizes;
  }
}

class ProductVariant {
  constructor(el) {
    this.el = el;
    this.url = el.dataset.variantUrl;
    this.price = el.dataset.variantPrice;
    this.src = el.dataset.variantSrc ?? false;
    this.srcset = el.dataset.variantSrcset ?? false;
    this.sizes = el.dataset.variantSizes ?? false;

    this._selected = this.el.getAttribute('aria-current') === 'true';
  }

  destroy() {
    this.el = null;
    this.url = null;
    this.price = null;
    this.src = null;
    this.srcset = null;
    this.sizes = null;

    this._selected = null;
  }

  // getter - setter
  get selected() { return this._selected; }
  set selected(value) {
    if( this._selected === value ) return;

    this._selected = value;
    this.el.setAttribute('aria-current', this._selected);
  }
}

export default ProductPreview;
